<script setup>
import { onMounted } from 'vue'
import VideoPlayer from '../../VideoPlayer.vue'

defineProps({
  item: Object,
})

const videoElement = ref(null)

onMounted(async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ video: true })
    videoElement.value.srcObject = stream
  } catch (error) {
    console.error('Error accessing webcam:', error)
  }
})
</script>

<template>
  <VideoPlayer
    :style="{
      left: `${item.properties.position.xLeft}px`,
      top: `${item.properties.position.yTop}px`,
      width: `${item.properties.position.width}px`,
    }"
    class="absolute"
    autoplay
    @videoElement="videoElement = $event"
  />
</template>
